define('lq/cookie',[],function () {

    var get = function(cname) {
        var name = cname + '=';
        var ca = document.cookie.split(';');

        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1);
            if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
        }

        return null;
    };

    var set = function (cname, cvalue, expiryInDays) {
        var expiryDate = new Date();
        expiryDate.setDate(expiryDate.getDate() + (expiryInDays || (365 * 20)));

        // for now using '/' as the path is not really an issue
        document.cookie = cname + '=' + cvalue + ';path=/;expires=' + expiryDate.toUTCString();
    };

    var remove = function (cname) {
        set(cname, '', -1);
    };

    return {
        get: get,
        set: set,
        remove: remove
    };

});
